<!-- Loader [START] -->
<div id="loading" [@inOutAnimation]="settingService.loader" *ngIf="settingService.loader">
  <div id="loading-center"></div>
</div>
<!-- Loader [END] -->
